/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import DealerSearch from './components/dealer-search';
import actionCreators from './action-creators';
import { connect } from 'react-redux';
import { validateDealerSearchCriteria } from './service/search-params';
import { withAuth } from '@okta/okta-react';

const getStateToBindToContainerProps = (state) => ({
    ...state.application.productDealerSearch,
    isDealerSearchValid: validateDealerSearchCriteria(state.application.productDealerSearch.searchParams),
    isModalVisible: state.application.createTransfer.dealerSearchModal.isVisible,
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
    },
});

// eslint-disable-next-line max-len
export default connect(
    getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp,
)(withAuth(DealerSearch));
